module.exports = __webpack_public_path__ + "static/media/elements.06f6a485.png";